<div class="dtf-insurance">

  <style>
    .mbfs-home-hero {
        background-image: url('/static/assets/img/dtf-assets/images/redesign/BannerTest.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
      }

      .mbfs-repay-banner-inner__box--text2{
        margin: 20px; font-weight: bold; font-size: 50px;
      }

      .mbfs-repay-banner-inner__header-title {
      font-size: 2.374rem;
     }

    @media (max-width: 1366px) {
      .mbfs-home-hero {
        background-image: url('/static/assets/img/dtf-assets/images/redesign/Tablet.jpg');
        width: 100%; /* image will take full width of its container */
        height: 700px; 
      }
    }
  
    @media (max-width: 667px) {
      .mbfs-home-hero {
        background-image: url('/static/assets/img/dtf-assets/images/redesign/Mobile.jpeg');
        width: 100%;
        height: 430px;
        background-position: center;
      }

      .mbfs-repay-banner-inner__box--text2{
        margin: 20px; font-weight: bold; font-size: 19px;
      }

      .mbfs-repay-banner-inner__header-title {
      font-size: 1.374rem;
    }
    }
  </style>

    <section class="mbfs-home-hero">
    </section>

    <section class='mbfs-repay-banner-inner'>
        <div class="mbfs-repay-banner-inner__box">
            <div class="mbfs-repay-banner-inner__box--text2">
              {{ 'DynamicPortal.unsubscribe' | translate }}
            </div>
        </div>
    </section>

    <br><br><br><br>
    
    <section class='mbfs-repay-banner-inner' style="background-color: #E6E6E6;">
    <div class="mbfs-repay-banner-inner__box">
      <div class="mbfs-repay-banner-inner__box--text2">
        <h5 class="mbfs-repay-banner-inner__header-title" style="color: black; ">
            {{ 'DynamicPortal.titleremove' | translate }}
            <br><br>
            {{ 'DynamicPortal.sorry' | translate }}
        </h5>
      </div>
    </div>
  </section>

  <br><br>

  <button class="mbfs-button" style="background-color: #00566A; display: block; margin: auto;" (click)="goToHomepage()">{{ 'DynamicPortal.back' | translate }}</button>

  <br><br>

</div>